const compliancePageDataAr = {
  mainTitle : "الامتثال للقوانين والأنظمة",
  headerImage : {
      name : "compliance.jpg",
      alt : "Compliance with regulations description"
  },
  paragraphOne : "يلتزم بنك الأول بمستوى عالٍ من الامتثال لقوانين وأنظمة المملكة. و في عام 2022، بلغ إجمالي حوادث عدم التزام البنك بتعليمات البنك المركز السعودي كما يلي:",
  tableOne : {
      table : {
          headers : [
              <span>حالات عدم الامتثال</span>, 
              <span>2020</span>, 
              <span>2021</span>, 
              <span>2022</span>, 
          ],
          data : [
              {
                  element : "إجمالي حوادث عدم الالتزام بتعليمات البنك المركز السعودي",
                  2020 : "22",
                  2021 : "15",
                  2022 : "26",
              },
              {
                  element : "إجمالي عدد خطابات التحذير غير النقدية",
                  2020 : "1",
                  2021 : "2",
                  2022 : "6",
              },
              {
                  element : "النسبة المئوية لحالات عدم الامتثال التي نتجت عن إجراءات الإبلاغ عن المخالفات",
                  2020 : "-",
                  2021 : "-",
                  2022 : "-",
              },
          ],
          note : 'خضع هذا المقياس للسنة المنتهية في 31 ديسمبر 2022 لتأكيد محدود ومستقل من جانب شركة برايس ووترهاوس كوبرز للمحاسبين القانونيين ("PwC")، وللحصول على تفاصيل إضافية، يُرجى الاطلاع على معايير إعداد التقارير لدينا وتقرير التأكيد المحدود لشركة بي دبليو سي عبر زيارة الموقع الإلكتروني (الرابط).',
      },
  },
  paragraphTwo : "لنظرة شاملة عن حالات عدم امتثال بنك الأول من قبل البنك المركزي السعودي والجهات التنظيمية الأخرى، يمكنكم الاطلاع على الصفحة رقم 124 من التقرير السنوي للبنك.",
  paragraphThree : "لم تكن هناك حالات عدم امتثال تتعلق بالتأثير البيئي للبنك أو الإفصاح عن معلومات المنتجات والخدمات أو الشفافية أو الاتصالات التسويقية.",
  paragraphFour : "فيما يخص الحالات التي وقعت، تم إعداد تقرير مفصل عن كل حالة يحدد السبب الجذري وخطة عمل الإدارة لضمان عدم تكرار مثل هذه الحالات.",
  sectionOne : {
      title : "الإبلاغ عن المخالفات",
      paragraphOne : "يحافظ الأول على ثقافة مؤسسية تشجع الموظفين على الإبلاغ عن الممارسات الخاطئة أو غير الأخلاقية، حيث يمنح البنك الموظفين فرصة للإبلاغ عن أي سلوك غير أخلاقي من خلال القنوات الداخلية والخارجية، مع إخفاء الهوية بشكل تام إذا رغبوا في ذلك. ويوجد لدى البنك سياسة قوية للإبلاغ عن المخالفات تتم مراجعتها واعتمادها سنوياً من قبل مجلس الإدارة، والتي تضمن تحديد جوانب المخاوف وتقييمها والتحقيق فيها بدقة وأن موظفينا يمكنهم رفع الشكاوى دون خوف من ردود فعل.",
      paragraphTwo : "وفيما يلي قنوات الإبلاغ الآمنة للبنك للإبلاغ الداخلي والخارجي عن المخالفات:",
      orderedList : [
          <li>أ. البريد الإلكتروني (داخلي وخارجي): SpeakUp@sab.com</li>,
          <li>ب. الهاتف: داخلي (4440)، خارجي 0112764440</li>,
          <li>
              ج. البريد:<br />
              <ul className="normal-list">
                  <li>البريد الداخلي بالمقر الرئيسي بالرياض - الدور الرابع - مكتب وحدة الإبلاغ عن المخالفات</li>
                  <li>عنوان البريد الخارجي - المقر الرئيسي: ص.ب 9084 الرياض 11413 وحدة الإبلاغ عن المخالفات</li>
              </ul>
          </li>,
          <li>د. الموقع الإلكتروني: www.sab.com</li>,
          <li>هـ. البوابة الداخلية: إبداء الرأي (الخط الساخن للإبلاغ عن الحالات المتعلقة بالامتثال)</li>,
      ],
      paragraphThree : "يتم التعامل مع الشكاوى المقدمة بسرية تامة، حيق يتم اتخاذ خطوات لفصل وحماية الاتصالات والتقارير والمعلومات الإدارية التي قد تحدد هوية المبلغين عن المخالفات، ولا يتم الكشف عن هويات المبلغين عن المخالفات دون أسباب استثنائية وجيهة، مثل الحالات التي يقتضي فيها القانون ذلك أو لتسهيل إجراءات تحقيق معينة."
  },
  tableTwo : {
      table : {
          headers : ["مراقبة الامتثال الداخلي والإبلاغ", "2020", "2021", "2022"],
          data : [
              {
                  element : "عدد الاستفسارات أو الشكاوى أو القضايا التي يتلقاها مكتب الشؤون القانونية والامتثال من خلال نظام مراقبة داخلي أو إبلاغ",
                  2020 : "208",
                  2021 : "266",
                  2022 : "373",
              },
              {
                  element : "النسبة المئوية للاستفسارات أو الشكاوى أو القضايا التي يتلقاها مكتب الشؤون القانونية والامتثال من خلال نظام رقابة داخلي أو نظام إبلاغ والتي تم إثباتها",
                  2020 : "%100",
                  2021 : "%100",
                  2022 : "%100",
              },
          ]
      },
      paragraph : "يتم تقديم ملخص لحالات الإبلاغ عن المخالفات المستلمة كل ربع سنة إلى مجلس الإدارة ولجنة المراجعة المنبثقة عنه.",
  },
  sectionTwo : {
      title : "الجرائم المالية",
      paragraphOne : "تشكل جميع اللوائح والتوجيهات والتعليمات الصادرة عن البنك المركزي السعودي فيما يخص مكافحة غسل الأموال وتمويل الإرهاب جزءاً لا يتجزأ من سياسة الأول لمكافحة غسل الأموال وتمويل الإرهاب.", 
      paragraphTwo : "يهدف البنك إلى الامتثال لأعلى معايير ممارسات مكافحة أنشطة غسل الأموال وتمويل الإرهاب، بنص وروح القوانين واللوائح المعمول بها في المملكة العربية السعودية. وقد يقوم البنك بتطبيق معايير أكثر صرامة عند اللزوم لحماية سمعته والحفاظ عليها.",
      paragraphThree : "يستخدم الأول حلاً مملوكاً له كبرنامج مراقبة المعاملات القائم على درجة المخاطر، حيث يتم تحديد جميع أنواع المعاملات في النظام، ما يسمح بإنشاء ملفات تعريف سلوكية، ويتم رصد السلوك المشبوه بناءً على نموذج مراقبة المعاملات المرن المعمول به في النظام.      لمزيد من المعلومات حول منهجية البنك للتخفيف من مخاطر الجرائم المالية، يمكنكم الاطلاع على قسم إدارة المخاطر في التقرير السنوي للبنك.",
      titleTwo : "مكافحة الفساد",
      paragraphFour : "يطبق البنك نهجاً شديد الصرامة مع حالات الرشوة والفساد، حيث تحدد سياسة مكافحة الرشوة والفساد الخاصة بالبنك الحد الأدنى من المعايير التي يجب اتباعها على مستوى البنك، لضمان تطبيق منهجية ثابت وموحدة لإدارة مخاطر الرشوة والفساد. وتغطي هذه السياسة معايير تقييم المخاطر فيما يخص تقديم الهدايا والترفيه، والمبالغ النقدية لتسهيل المعاملات، والتوظيف، والتعاقد، والمساهمات ذات الطابع السياسي.",
      paragraphFive : "وبجانب هذه السياسة، يحرص البنك على توفير دورات التعلم الإلكتروني الإلزامية بشأن الجرائم المالية لجميع الموظفين (بما في ذلك الموظفون الدائمون وموظفو العقود) حيث يتم تذكير الأفراد بمسؤوليتهم الخاصة بمكافحة الرشوة والفساد. كما يتم عقد توعية حول مخاطر الامتثال الرئيسية لأعضاء مجلس الإدارة أيضاً بشكل سنوي، ومن المقرر أن يتم عقد الدورة التدريبية التالية خلال شهر مايو 2023:"
  },
  tableThree : {
      table : {
          headers : ["اسم الدورة التدريبية", "ملخص محاور الدورة", "المدة الزمنية (التقريبية)", "التقييم"],
          data : [
              {
                  name :  "مكافحة الاحتيال والرشوة والفساد",
                  summary : [
                      "مقدمة عن الاحتيال في القطاع المصرفي",
                      "التهديدات السيبرانية / الاحتيال والاحتيال باستخدام أنظمة الكمبيوتر",
                      "تحديد المخاطر",
                      "الحوكمة ومكافحة الاحتيال",
                      "الضوابط الداخلية الحديثة لمكافحة الاحتيال الإبلاغ عن المخالفات",
                  ],
                  length : "45 دقيقة",
                  assessment : "يوجد تقييم",
              }
          ]
      }
  },
  tableFour : {
      paragraph : "فيما يلي ملخص لدورات التدريب الإلزامية بالبنك خلال العام 2022:",
      table : {
          headers : ["اسم الدورة التدريبية", "ملخص محاور الدورة", "المدة الزمنية (التقريبية)", "التقييم", "نسبة استكمال الدورة"],
          data : [
              {
                  name : "الصحة والسلامة في مكان العمل - 2022",
                  summary : {
                      list : [
                          "التعريف بالإجراءات الإيجابية للسلامة في مكان العمل.",
                          "تعريف الصحة المهنية",
                          "إظهار مشاكل الاضطرابات العضلية الهيكلية الشائعة.",
                          "توضيح أهمية الحفاظ على مناطق العمل نظيفة وخالية من الجراثيم والبكتيريا.",
                          "تعريف السلامة من الحرائق.",
                          "شرح كيفية استخدام مطفأة الحريق.",
                          "التعرف على حالة الطوارئ الطبية."
                      ]
                  },
                  length : "45 دقيقة",
                  assessment : "يوجد تقييم",
                  progress : "%98.38",
              },
              {
                  name : "أمن البريد الإلكتروني 2022",
                  summary : {
                      list : [
                          "فهم الحاجة إلى أمن البريد الإلكتروني.",
                          "بيان إجراءات حماية أمان البريد الإلكتروني المختلفة.",
                          "شرح أنواع مختلفة من تهديدات البريد الإلكتروني.",
                          "التعرف على رسائل البريد الإلكتروني المشبوهة / الضارة.",
                          "تحديد قناة الإبلاغ الصحيحة عن رسائل البريد الإلكتروني الضارة."
                      ],
                  },
                  length : "45 دقيقة",
                  assessment : "يوجد تقييم",
                  progress : "%98.43",
              },
              {
                  name : "وثيقة مبادئ الأول الإلزامية",
                  summary : {
                      text : "تغطي مبادئ الأول جميع السياسات والإجراءات، كما تعرف وتربط بين أهداف البنك وقيمه واستراتيجيته وإدارة المخاطر لديه."
                  },
                  length : "30 دقيقة",
                  assessment : "لا يوجد تقييم",
                  progress : "%98.15",
              },
              {
                  name : "التحرش في مكان العمل 2022",
                  summary : {
                      list : [
                          "ما المقصود بالتحرش. ما الذي تعرفه عن قواعد مكافحة التحرش في مكان العمل.",
                          "آثار التحرش في مكان العمل.",
                          "سياسة التحرش لدى الأول.",
                          'ما الذي يعتبر "مضايقة".',
                          "طرق وأشكال التحرش.",
                          "تعريفات أنواع التحرش."
                      ],
                  },
                  length : "45 دقيقة",
                  assessment : "يوجد تقييم",
                  progress : "%98.03",
              },
              {
                  name : "حماية المعلومات الخاصة بنا 2022",
                  summary : {
                      list : [
                          "التعرف على كيفية الحفاظ على أمن المعلومات في جميع المواقع.",
                          "الكشف عن التصيد الإلكتروني.",
                          "إظهار أهمية أمن المعلومات.",
                          "إظهار كيفية التعامل مع رسائل التصيد عبر البريد الإلكتروني.",
                          "شرح تصنيف المعلومات.",
                          "تعريف المخاطر.",
                          "معرفة كيفية حماية المعلومات.",
                          "تحديد كيفية وتوقيت الإبلاغ عن الحالات المتعلقة بأمن المعلومات في مكان العمل.",
                      ],
                  },
                  length : "45 دقيقة",
                  assessment : "يوجد تقييم",
                  progress : "%97.21"
                  
              },
              {
                  name : "مسؤولياتي المتعلقة بمخاطر الجرائم المالية 2022",
                  summary : {
                      text : "مكافحة التستر التجاري وعقوبات جرائم غسل الأموال",
                  },
                  length : "45 دقيقة",
                  assessment : "يوجد تقييم",
                  progress : "%99.80",
              },
          ]
      }
  },
  sectionThree : {
      image : {
          name : "compliance-1.jpg",
          alt : "Highlight and challenges description"
      },
      shortText : "لم يشهد البنك وقوع أي حالات فساد مثبتة خلال العام 2022.",
      title : "أبرز الأحداث والتحديات خلال العام 2022",
      subtitle : "سارعت المملكة في تبني الحلول الرقمية أثناء الجائحة، وشهد القطاع المصرفي ارتفاعاً طفيفاً في عمليات الاحتيال المنظم في الهندسة الاجتماعية. بينما تستهدف هذه الهجمات العملاء، يسعى الأول والجهات الفاعلة الأخرى في القطاع المصرفي جاهدين لمكافحة هذا النوع من الاحتيال. كما أصدر البنك المركزي السعودي إطار عمل قوياً لمكافحة الاحتيال في أكتوبر 2022، ومن المتوقع أن تحقق البنوك المستوى الثالث من النضج بحلول يونيو 2023.",
  },
  sectionFour : {
      title : "المراجعة الداخلية والممارسات البيئية والاجتماعية والحوكمة المؤسسية",
      paragraphOne : "تماشياً مع استراتيجية الممارسات البيئية والاجتماعية والحوكمة المؤسسية الخاصة بالبنك، تعمل تغطية المراجعة الداخلية على تقييم الأثر البيئي والاجتماعي للتمويل المقدم من البنك. وعند رصد أية نقاط ضعف، يتم وضع خطط العمل ومراقبتها لحلها بشكل فعال. ويقوم قطاع الخدمات المصرفية للشركات والمؤسسات بمراجعة تصنيفات مخاطر الاستدامة (SRR) المخصصة لعملاء الخدمات المصرفية للشركات.",
      paragraphTwo : "خلال عام 2022، لعبت إدارة المراجعة الداخلية دوراً حيوياً في دعم استراتيجية البنك الشاملة للممارسات البيئية والاجتماعية والحوكمة المؤسسية. وشمل ذلك مراجعة مدى كفاية تصنيفات مخاطر الاستدامة المخصصة للعملاء والتوصية برقمنة التقارير وإجراءات العمل الأخرى للحد من انبعاثات الكربون.",
      paragraphThree : "يحرص البنك على الالتزام بجميع لوائح البنك المركزي السعودي، بما في ذلك تلك المتعلقة بالمراجعة السنوية، والمراقبة، والإدارة، والإبلاغ عن نتائج المراجعة. ويقوم فريق التدقيق الداخلي بدور خط الدفاع الثالث للبنك، والذي يقدم تأكيداً غير منحاز لمجلس الإدارة بأن كلاً من الخط الأول (وظائف الأعمال والتشغيل) والخط الثاني (وظائف إدارة المخاطر والرقابة) يعملان بنجاح ضمن نطاق تقبل المخاطر لدى البنك.",
      paragraphFour : "تم تنفيذ منهجية مصفوفة مراقبة المخاطر المحدثة من قبل إدارة المراجعة الداخلية وفقاً لمعايير معهد المراجعين الداخليين (1220 و2200 و 2201)؛ حيث تم استبدال تقييم مخاطر المراجعة (ARA) وبرامج المراجعة (APG) المستخدمة سابقاً. وتهدف مصفوفة مراقبة المخاطر إلى جعل عملية المرجعة بشكل كامل شفافة، وتعتبر المصفوفة من العوامل شديدة الأهمية لتقييم المخاطر وتخطيط المراجعة، وإظهار اختبار الضوابط المهمة وتجميع النتائج والتوصيات من اختبار المراجعة في وثيقة واحدة.",
      table : {
          headers : ["العام", "2021", "2022", "2023 (مخطط)"],
          data : [
              {
                  year : "عدد عمليات المراجعة",
                  2021 : "21",
                  2022 : "28",
                  2023 : "28",
              }
          ]
      }
  },
  sectionFive : {
      title : "ملخص عمليات المراجعة خلال العام 2020",
      table : {
          headers : ["رقم المراجعة", "عمليات المراجعة خلال 2022"],
          data : [
              "مراجعة إدارة الممتلكات (الملكية الفكرية والأمن المادي مجتمعين)",
              'مراجعة العمليات والضوابط الخاصة بالبنك "تحديد مخاطر المراجعة الائتمانية"',
              "مراجعة إدارة التسويق",
              "مراجعة موضوعية لمنتجات قروض التجزئة",
              "مراجعة موضوعية على إدارة المصرفية الإسلامية",
              "مراجعة حوكمة تقنية المعلومات ودورة حياة التطوير",
              "المراجعة التنظيمية لنظام سريع",
              "مراجعة حسابات الشركات الكبيرة",
              "الحوكمة (أمين عام المجموعة والاتصالات)",
              "مراجعة عمليات وضوابط الموارد البشرية",
              "مراجعة موضوعية لإدارة المخاطر السيبرانية",
              "مراجعة عملية التقييم الداخلي لكفاية السيولة (ILAAP) 2022",
              "مراجعة تنظيمية لإدارة مخاطر الاحتيال (خارج المخطط)",
              "مراجعة عمليات شركة عقارات العربية المحدودة (أريكو)",
              "مراجعة العمليات والضوابط الخاصة بإدارة الشؤون القانونية",
              "مراجعة العمليات والضوابط الخاصة بإدارة النقد والسيولة العالمية ",
              "مراجعة عملية التقييم الداخلي لكفاية رأس المال (ICAAP) 2022",
              "الخدمات المصرفية الرقمية",
              "مراجعة الامتثال التنظيمي",
              "مراجعة تنظيمية لإجراءات معياري سايبور / سايبيد",
              "مراجعة موضوعية لإطار عمل إدارة المخاطر التشغيلية",
              "مراجعة البنية التحتية لتقنية المعلومات العمليات",
              "مراجعة فروع البنك",
              "مراجعة موضوعية لمخاطر ائتمان التجزئة",
              "مراجعة تنظيمية لنظام مدى",
              "مراجعة موضوعية لعمليات ائتمان الشركات",
              "مراجعة الشركات العالمية والخدمات المصرفية المؤسسية",
              "مراجعة التقييم السنوي لنضج الأمن السيبراني",
          ],
          paragraphOne : "وخلال العام 2023، وتماشياً مع متطلبات إدارة المراجعة الداخلية الخاصة بدورات التعلم الإلزامي، سيوفر البنك للموظفين تدريباً متعلقاً بالممارسات البيئية والاجتماعية والحوكمة المؤسسية، حيث يهدف هذا التدريب الإلزامي إلى تعميق الوعي بالمسائل المتعلقة بالممارسات البيئية والاجتماعية والحوكمة المؤسسية لدى البنك، بالإضافة إلى تحسين قدرة البنك على مراقبة وتقييم المبادرات المتعلقة بهذه الممارسات بشكل أكثر صرامة.",
          paragraphTwo : "لمزيد من المعلومات حول إدارة المخاطر والامتثال التنظيمي والمراجعة الداخلية لدى الأول، يمكنكم الاطلاع على التقرير السنوي للبنك."
      }
  }
};

export default compliancePageDataAr;